import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { AdminNavEntryPointV2, AdminNavEntryPointV3 } from '@retailer-platform/dashboard/routing'
import { storefrontShortcutsBarAdminRouter } from './routing/storefrontShortcutsBarRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { storefrontShortcutsBarAccessControl } from './access-control/storefrontShortcutsBarAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'storefront-shortcuts-bar',
  totem: {
    tool: 'shortcuts-bar-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  routers: {
    admin: [storefrontShortcutsBarAdminRouter],
  },
  adminNavigationEntries: [
    {
      attachToV2: AdminNavEntryPointV2.Merchandising,
      attachToV3: AdminNavEntryPointV3.Marketplace,
      subNavItems: [
        {
          route: 'app-admin-storefront-shortcuts-bar',
          subRoutes: [
            'app-admin-storefront-shortcuts-bar-retailer-category-edit',
            'app-admin-storefront-shortcuts-bar-retailer-edit',
          ],
          labelId: 'storefrontShortcutsBarDomain.title',
          accessControl: storefrontShortcutsBarAccessControl,
        },
      ],
    },
  ],
  navigationEntries: [],
}

export default definition
